"use client";

import { logger } from "@/lib/logger";
import { useDidMount } from "@/ui/hooks/lifecycle";

declare global {
	interface Window {
		__ynsSentryReplayLoaded__?: boolean;
	}
}

export const SentryReplaySession = () => {
	useDidMount(() => {
		if (typeof window === "undefined") {
			return;
		}
		if (window.__ynsSentryReplayLoaded__) {
			return;
		}
		window.__ynsSentryReplayLoaded__ = true;

		import("@sentry/nextjs").then((lazyLoadedSentry) => {
			logger.debug("replayIntegration loaded");
			// @todo we might consider turning off replay integration in the future
			lazyLoadedSentry.addIntegration(
				lazyLoadedSentry.replayIntegration({
					maskAllText: false,
					maskAllInputs: false,
					blockAllMedia: false,
				}),
			);
		});
	});
	return null;
};
